<template slot="header" slot-scope="scope">
<div>
    <el-table :data="tableData" style="width: 100%" max-height="1000">
    <el-table-column  prop="state"   label="状态" min-width="150" :formatter="stateFormat">
    </el-table-column>
    <el-table-column prop="co" label="数量" min-width="120">
    </el-table-column>
  </el-table>
</div>

</template>

<script>
import rootPathssb from '@/api/mainApi'
import { dataGetUrl } from '@/api/index'
export default {
  name: 'adminevaluatelist',
  data () {
    return {
      tableData: [],
      eventIsstate: false,
      searchName: '',
      isState: '',
      delId: '',
      delIndex: '',
      pageSize: 15,
      currentPage: 1,
      total: 0,
      pagenow: 1

    }
  },
  created () {
    var that = this
    console.log(this)
    dataGetUrl(rootPathssb.rootPath + '/admini/steam/app').then(function (response) {
      that.checkSignin(response.data.result)
      console.log(response.data); console.log('bbb')
      that.tableData = response.data.resList
      that.total = response.data.info
      that.pagenow = response.data.info
    }).catch(function (error) {
      console.log(error)
      console.log('aaa')
    })
  }, // 页面加载时
  methods: {
    getPageDate (event) {
      let that = this
      dataGetUrl(rootPathssb.rootPath + '/admini/steam/app?pagenow=' + this.pagenow).then(function (response) {
        if (response.data.result === 1) {
          that.eventsList = response.data.info.list
          console.log('cg')
        };console.log(response.data)
      }).catch(function (error) {
        console.log(error); console.log(2222222222)
      })
    }, // 获取数据
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
      this.pageSize = val// 获取page-sizes里的每页显示几条数据的值，赋给我们自定义的每页显示数量的变量pageNum
    }, // 每页个数变化
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.pagenow = val
      this.getPageDate()
    }, // 第几页
    handleprevclick (val) {
      this.currentPage = val - 1
      this.pagenow = val - 1
      this.getPageDate()
      console.log(this)
    }, // 上一页
    handlenextclick (val) {
      this.currentPage = val + 1
      this.pagenow = val + 1
      this.getPageDate()
    }, // 下一页
    checkSignin (sta) {
      if (sta === -1) {
        window.location.href = '/signin'
      }
    },
    autSearch () {
      var that = this
      console.log(this)
      dataGetUrl(rootPathssb.rootPath + '/admini/news/list?serchname=' + that.searchName).then(function (response) {
        that.checkSignin(response.data.result)
        console.log(response.data); console.log('bbb')
        that.tableData = response.data.info.list
        that.total = response.data.info.total
        that.pagenow = response.data.info.currentPage
      }).catch(function (error) {
        console.log(error)
        console.log('aaa')
      })
    },
    stateFormat (row, column) {
      if (row.state === '0') {
        return '待受理'
      } if (row.state === '1') {
        return '受理中'
      } if (row.state === '2') {
        return '完成'
      }
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/adminevaluatelist.vue